module.exports = __webpack_public_path__ + "img/hacienda-room-7.ca8165bc.jpg";